(function () {
  'use strict';

  function config ($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.orders', {
        url: '/orders',
        templateUrl: 'components/orders/orders.html',
        controller: 'OrdersController',
        controllerAs: 'ctrl',

        onEnter: function (breadcrumbFactory) {
          const breadcrumbs = [{
            url: '/',
            label: 'START'
          }, {
            state: 'main.orders',
            label: 'ORDERS'
          }];

          breadcrumbFactory.changeBreadcrumbs(breadcrumbs);
        }
      })
      .state('main.order', {
        url: '/order/:id',
        templateUrl: 'components/orders/orders.html',
        controller: 'PreviewOrderCtrl',
        controllerAs: 'ctrl',
        onEnter: function (breadcrumbFactory, $stateParams) {
          const breadcrumbs = [{
            url: '/',
            label: 'START'
          }, {
            state: 'main.orders',
            label: 'ORDERS'
          }];

          breadcrumbFactory.changeBreadcrumbs(breadcrumbs);
        },

        onExit: function (Common) {
          Common.set('orderPdf', null);
        }
      });
  }

  angular.module('web2print.orders')
    .config(config);
})();
